module.exports = __webpack_public_path__ + "img/6-original.d733feb7.svg";